import cn from 'classnames'
import './StatusBanner.scss'

interface Props {
  status: string
}

function StatusBanner({ status }: Props) {
  return <div className={cn('status-banner', status.toLowerCase()?.replace(' ', '-'))}>{status}</div>
}

export default StatusBanner
